module.exports = __webpack_public_path__ + "static/media/apple_store.d293668c.png";